import { observable, action, computed } from 'mobx';

export default class TimelistWorkflowStepLineItemStore {
    @observable exclude;
    @observable excludeFromWorkflow;
    @observable excludeFromEmailGrid;
    @observable excludeFromCalendarReminders;
    @observable deadlineDays;
    @observable previousDeadlineDays;
    @observable name;

    constructor(
        exclude,
        excludeFromWorkflow,
        excludeFromEmailGrid,
        excludeFromCalendarReminders,
        days,
        name,
        eventId,
        updateDays,
        updateExclude,
        updateName,
        updateExcludeFromWorkflow,
        updateExcludeFromEmailGrid,
        updateExcludeFromCalendarReminders
    ) {
        this.exclude = exclude;
        this.excludeFromWorkflow = excludeFromWorkflow;
        this.excludeFromEmailGrid = excludeFromEmailGrid;
        this.excludeFromCalendarReminders = excludeFromCalendarReminders;

        this.deadlineDays = days;
        this.previousDeadlineDays = days;
        this.name = name;
        this.eventId = eventId;
        this.updateStoreDays = updateDays;
        this.updateStoreExclude = updateExclude;
        this.updateStoreExcludeFromWorkflow = updateExcludeFromWorkflow;
        this.updateStoreExcludeFromEmailGrid = updateExcludeFromEmailGrid;
        this.updateStoreExcludeFromCalendarReminders = updateExcludeFromCalendarReminders;
        this.updateStoreName = updateName;

        if (exclude) {
            this.updateExcludeFromCalendarReminders(exclude);
            this.updateExcludeFromWorkflow(exclude);
        }
    }

    @action updateExclude(exclude) {
        this.exclude = exclude;
        if (this.exclude) {
            this.previousDeadlineDays = this.deadlineDays;
            this.updateDeadlineDays('');

            this.updateExcludeFromEmailGrid(false);
            this.updateExcludeFromCalendarReminders(exclude);
            this.updateExcludeFromWorkflow(exclude);
        } else {
            this.updateDeadlineDays(this.previousDeadlineDays);
            this.updateExcludeFromCalendarReminders(false);
            this.updateExcludeFromWorkflow(false);
        }
        this.updateStoreExclude(this.eventId, this.exclude);
    }

    @action updateExcludeFromWorkflow(excludeFromWorkflow) {
        this.excludeFromWorkflow = excludeFromWorkflow;
        this.updateStoreExcludeFromWorkflow(this.eventId, this.excludeFromWorkflow);
    }

    @action updateExcludeFromEmailGrid(excludeFromEmailGrid) {
        this.excludeFromEmailGrid = excludeFromEmailGrid;
        this.updateStoreExcludeFromEmailGrid(this.eventId, this.excludeFromEmailGrid);
        if (excludeFromEmailGrid) {
            this.updateExclude(!excludeFromEmailGrid);
        }
    }

    @action updateExcludeFromCalendarReminders(excludeFromCalendarReminders) {
        this.excludeFromCalendarReminders = excludeFromCalendarReminders;
        this.updateStoreExcludeFromCalendarReminders(this.eventId, this.excludeFromCalendarReminders);
    }

    @action updateDeadlineDays(days) {
        if (days <= 730) {
            this.deadlineDays = days;
            this.updateStoreDays(this.eventId, days);
        }
    }

    @action updateName(name) {
        this.name = name;
        this.updateStoreName(this.eventId, name);
    }

    @computed get nameIsInvalid() {
        return this.name === '';
    }

    @computed get deadlineDaysIsInvalid() {
        return (
            this.deadlineDays === null ||
            this.deadlineDays === '' ||
            (Number.isInteger(parseInt(this.deadlineDays)) && parseInt(this.deadlineDays) < 0)
        );
    }

    @computed
    get excludeFromWorkflowDisabled() {
        return this.exclude;
    }

    @computed
    get excludeFromCalendarRemindersDisabled() {
        return this.exclude;
    }
}



// WEBPACK FOOTER //
// ./src/workflow/steps/timeline/timeline-workflow-step-lineitem-store.js